import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SearchService } from '../search/search.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NavService } from '../header/nav/nav.service';
import { SharedService } from '../common/shared.service';
import { ISubscription } from 'rxjs/Subscription';
import { PortalService } from '../services/portal.service';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for search form at index 
 **/
@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, AfterViewInit, OnDestroy {

    keyword1: any;
    public popData: any = [];
    suggestions: any = [];
    loading: boolean = false;
    private lang;
    private languageId;
    private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  private searchJSONSubscription:ISubscription;
  private searchJSON: any;

    constructor(
        private portalService: PortalService,
        private sharedService: SharedService,
        private translate: TranslateService,
        private router: Router,
        public navService: NavService,
        private searchService: SearchService,
        private toastr: ToastrService
    ) {

        if (!this.languageId) {
            if (localStorage.getItem('langID')) {
              this.languageId = localStorage.getItem('langID');
            } else { 
              this.languageId = 1;
            }
        }

        this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
            this.fontSize = data;      
          });
        
        this.searchJSONSubscription = this.sharedService.searchJSON.subscribe((data)=> {
            if (data && Object.keys(data).length!=0) {
              this.searchJSON = data;
            }
        });
      
    }

    getTheme() {
        return localStorage.getItem('themeColor');
    }

    closeList(e) {
        // console.log({'event':e});
        // console.log({'className':e.target.className});
        // console.log({'ispopUpShow':this.navService.ispopUpShow});
        // console.log({'isNavSuggestionList':this.navService.isNavSuggestionList});
        // console.log({'isHomeSearchSuggestionList':this.navService.isHomeSearchSuggestionList});
        // console.log({'isSearchSuggestionList':this.navService.isSearchSuggestionList});
        if(e.target.className === "hover_bkgr_fricc" && this.navService.ispopUpShow && (this.navService.isNavSuggestionList || this.navService.isHomeSearchSuggestionList || this.navService.isSearchSuggestionList)) {
            this.navService.ispopUpShow = false;
            this.navService.isNavSuggestionList = false;
            this.navService.isHomeSearchSuggestionList = false;
            this.navService.isSearchSuggestionList = false;
        }
        
        $('.hover_bkgr_fricc').css({ 'display': 'none' });
                      
    }

    suggestionByGoogle(key) {
           
        this.portalService.readPortal('google/api/searchsuggest', '', '', '', 'q='+encodeURIComponent(key)).subscribe(res => {
    
          this.suggestions = res['suggestion'];
                  
          // console.log({'suggestions':this.suggestions});
    
          if(this.suggestions.length != 0) {
              $('.hover_bkgr_fricc').css({ 'display': 'block' });
              // this.suggestions = this.convert2arr(res['_body']);
              this.addHighlight(key);
              //this.navService.isSearchSuggestionList = true;
              //this.navService.ispopUpShow = true;
              this.navService.isHomeSearchSuggestionList = true;
              this.navService.ispopUpShow = true;
          }
    
        },
        error => {
            console.log(error);
        });
    
    }
    
    suggestionByAugeo(key, miageourl) {
    
    let url = miageourl;
    
    let keywordBody = {
        "keyword": encodeURIComponent(key)
    };
    
    
    this.portalService.getAutocompleteByUrl(keywordBody, url).subscribe(res => {
        let tempArr: any = [];
        tempArr = res;
        // console.log({'tempArr':tempArr});
        this.suggestions = [];
    
        if (tempArr['data'].length != 0) {
            tempArr['data'].forEach(el => {
                let dataObj = { 'data': null };
                // console.log({'el':el});
                dataObj.data = el.keyword[0];
                this.suggestions.push(dataObj);
            });
        }
        console.log({ 'suggestions': this.suggestions });
    
        if (this.suggestions.length != 0) {
            $('.hover_bkgr_fricc').css({ 'display': 'block' });
            // this.suggestions = this.convert2arr(res['_body']);
            this.addHighlight(key);
            this.navService.isHomeSearchSuggestionList = true;
            this.navService.ispopUpShow = true;
        }
    
    },
        error => {
            console.log(error);
        });
    
    }

    getSuggestions(key) {
        // let corsURL = 'https://cors-anywhere.herokuapp.com/';
        // let headers = new Headers({'Content-Type': 'text/xml'})
        // headers.set('Accept', 'text/xml');
        // headers.set('Content-Type', 'text/xml');
        // headers.set('X-Requested-With', 'test');
        this.suggestions = [];
        let suggestSource;
        let miageoUrl;
        if (this.searchJSON && this.searchJSON.active==true) {
          suggestSource =  this.searchJSON.type;
          miageoUrl = this.searchJSON.miaugeourl;
        } else if (this.searchJSON && this.searchJSON.active==false) {
          return;
        } else {
          suggestSource = 'google';
        }
    
        
            // this.loading = true;
        if(key && key.length != 0 && key.length >= 3){
            if (suggestSource == 'google') {
                this.suggestionByGoogle(key);
              } else {
                this.suggestionByAugeo(key, miageoUrl);
              }
            /*// this.http.get(corsURL+'https://suggestqueries.google.com/complete/search?output=toolbar&hl=en&q='+key,{headers}).subscribe(res => {
            this.portalService.readPortal('google/api/searchsuggest', '', '', '', 'q='+encodeURIComponent(key)).subscribe(res => {

                this.suggestions = res['suggestion'];

                if(this.suggestions.length != 0) {
                    $('.hover_bkgr_fricc').css({ 'display': 'block' });
                    // this.suggestions = this.convert2arr(res['_body']);
                    this.addHighlight(key);
                    this.navService.isHomeSearchSuggestionList = true;
                    this.navService.ispopUpShow = true;
                    // console.log({'suggestions':this.suggestions});
                } else {
                    this.navService.isHomeSearchSuggestionList = false;
                    this.navService.ispopUpShow = false;
                    this.autoCompleteArr = [];
                    // this.loading = false;
                }
        
            },
            error => {
                console.log(error);
                // this.loading = false;
            //   this.loading = false;
            //   this.commonservice.showError(JSON.parse(error._body).statusDesc, '');
            }); */
        } else {
            this.navService.isHomeSearchSuggestionList = false;
            this.navService.ispopUpShow = false;
            this.autoCompleteArr = [];
            // this.loading = false;
        }
        
    }

    addHighlight(keyword) {
        let span1 = document.createElement("span");
        let maintxt;

        this.suggestions.forEach(el => {

            maintxt = el.data;
            // console.log({'maintxt':maintxt});

            if (maintxt !== "null") {
                let nameNode = document.createTextNode(maintxt);
                span1.appendChild(nameNode);
                // console.log({'keyword':keyword});

                let resStr = this.highlight_words(keyword, span1);
                // if(resStr.trim().length > 300){
                //   this.dataHilight = resStr.slice(0,300) + '...';
                // }else{
                // } 
                el.hl = resStr;
                // this.dataHilight = el.data;
                // console.log({'dataHilight':this.dataHilight});
            } else {
            }
        });

    }

    highlight_words(word, element) {
        let regex: any = "";
        if (word) {
            var resData;
              word = word.replace(/\W/gi, '');
            var str = word.split(" ");

            $(str).each(function () {
                //   console.log({'str':str});

                var term = word;
                var textNodes = $(element).contents().filter(function () {
                    return this.nodeType === 3
                });
                textNodes.each(function () {

                    var content = $(this).text();
                    regex = new RegExp(term, "gi");

                    resData = content.replace(regex, (match) => `<span class="highlightWord">${match}</span>`);
                });
            });
            return resData;
        }
    }

    mainSearch(key) {

        if (key && key.trim().length > 0) {

            if(key.match(/script/gi)) { //  || key.match(/<\/?[^>]+(>|$)/g) || key.match(/[^a-zA-Z0-9 ]/g)
                console.log('invalid');
                
                key = '';
                this.keyword1 = '';
                this.sharedService.showError(this.translate.instant('common.msg.validsearchKeyword'), '');
            } else {

                if(key.match(/[a-zA-Z0-9]/g)) {
                    console.log('valid');
                    // key = decodeURIComponent(key);
                    // key = key.replace(/[^a-zA-Z0-9@&()[:space:]\.,'"\/-–]/g, "");
                    localStorage.setItem('ser_word', key);
                    
                    key = key.replace(/[&]/g, "|").replace(/[%]/g, "_");
                    
                    $('#searchDDown').css({ 'display': 'none' });
                    
                    location.href = './search?key=' + key;
    
                    this.internal(key);
                } else {
                    console.log('symbols only not valid');
                    
                    key = '';
                    this.keyword1 = '';
                    this.sharedService.showError(this.translate.instant('common.msg.validsearchKeyword'), '');
                }
                console.log({'key':key});
            }

        } else {
            //this.sharedService.showError(this.translate.instant('common.msg.searchKeyword'), '');
            this.sharedService.showError(this.translate.instant('common.msg.searchKeyword'), '');
        }
        // localStorage.setItem('ser_word', key);
        // this.router.navigate(['search/searchResult']);
        // this.internal(key);
    }

    internal(key) {

        let body = {
            "size": 10,
            "from": 0,
            "keyword": key,
            "filters": {
                "ranges":
                {
                    "end_date": [
                        {
                            "gte": "now/d",
                            "time_zone": "+08:00"
                        }
                    ]
                },
                "ref_language_id": this.languageId
            }
        }

        this.loading = true;
        this.searchService.getInternal(JSON.stringify(body)).subscribe(
            data => {
                this.searchService.setIntData(data);
                this.loading = false;
            });


    }

    //autocomplete data
    public autoCompleteArr = this.popData;

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.sharedService.loadFontSizeData();
    }

    ngOnDestroy() {
        this.subscriptionFontSize.unsubscribe();
    }


    getPop() {
        let body = {
            "size": 10,
            "filters": {
            }
        };
        // this.loading = true;
        this.navService.getPopularData(body)
            .subscribe(resPopularData => {
                this.popData = resPopularData;
                this.autoCompleteArr = this.popData;
                // this.loading = false;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts